import React from 'react'
import './About.css'
function About() {
  return (
    <div id="about">
      <h1>About</h1>
      <div className='about-card' > 
        <h3 className='text-bolder'> About Me:</h3>
        <h5 className='text-italic'>
          Full-Stack Software Engineer with 5+ years of experience building innovative
          solutions across Marketing, Real Estate, Finance, and Legal Tech industries. <br />
          Based in Madrid, Spain. Strong expertise in AI/ML technologies including LLMs,
          RAG systems, and NLP. Passionate about working with international teams from
          ideation to implementation.
        </h5>
      </div>
    </div>
  )
}

export default About